"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(x) {
  return function constant() {
    return x;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-shape/src/constant.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-shape/src/constant.js
// module chunks = 1